module.exports = __webpack_public_path__ + "static/media/qrprint-2.342dbfc2.png";